import { Routes } from '@angular/router';
import { LoginPageComponent } from './auth/pages/login-page/login-page.component';
import { UpdatePasswordComponent } from './auth/pages/update-password/update-password.component';
import { NotAuthroizedComponent } from './auth/pages/not-authroized/not-authroized.component';

import { RegisterPageComponent } from './auth/pages/register-page/register-page.component';
import { RecoverPasswordComponent } from './auth/pages/recover-password/recover-password.component';
import { LogoutComponent } from './auth/pages/logout/logout.component';
import { Erro404PageComponent } from './shared/pages/erro404-page/erro404-page.component';

export const routes: Routes = [
    // Redirect base path to dashboard (Camilo)
    { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    {
      path: 'dashboard',
      loadChildren: () => import('./dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES)
    },
    // Route for auth (Orion)
    { path: 'auth', component: LoginPageComponent },
    { path: 'logout', component: LogoutComponent },
    { path: 'error404', component: Erro404PageComponent },
    // Route for Register (Hector)
    { path: 'register', component: RegisterPageComponent },
    { path: 'recover-password', component: RecoverPasswordComponent },
    // Route for custom 404 page (Orion)

    // Route for not Authorized (Dilan)
    { path: 'not-authroized', component: NotAuthroizedComponent },

    // route for update password (Dilan)
    { path: 'update-password', component: UpdatePasswordComponent },
    // Route for logged out (Orion)

     // Wildcard route (catch-all) (Hector)
    { path: '**', redirectTo: 'error404' },

];
